export enum HeaderModal {
  Settings = 'settings',
  History = 'history',
  Help = 'help',
  QuickGuide = 'quickGuide',
  Chat = 'chat',
  Support = 'support',
}
